<template>
  <a-form
    :form="form"
    layout="inline"
    class="demo-form-inline"
    @submit.prevent="submitHandle"
  >
    <a-form-item>
      <a-popover
        title=""
        trigger="focus"
        overlay-class-name="input-tip-tip-box"
        :arrow-point-at-center="true"
        :destroy-tooltip-on-hide="true"
      >
        <template slot="content">
          <p>2-15{{ $t('message["368"]') }}</p>
        </template>
        <a-input
          v-decorator="['truename',
                        {rules: [{ required: true, message: truenamePlace }, {validator: validNameEr }], initialValue:itemData.truename || ''}]"
          :placeholder="truenamePlace"
          @change="getValue"
        />
      </a-popover>
      <!-- <span class="input-length-num">{{ valData?valData.length : 0 }}/10</span> -->
    </a-form-item>
    <a-form-item>
      <a-button
        type="primary"
        html-type="submit"
        class="sub-btn"
      >
        {{ $t('message["915"]') }}
      </a-button>
      <a-button @click="resetForm">
        {{ $t('message["896"]') }}
      </a-button>
    </a-form-item>
  </a-form>
</template>
<script>
import { mapActions } from 'vuex'
export default {
  props: {
    itemData: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  data () {
    return {
      isShow: false,
      submiting: false,
      valData: this.truername
    }
  },
  computed: {
    truenamePlace () {
      return this.$t('message["788"]')
    }
  },
  mounted () {
  },
  created () {
    this.form = this.$form.createForm(this)
  },
  methods: {
    ...mapActions('organization/person', ['ajaxEditTruename', 'validName']),
    submitHandle (formName) {
      this.form.validateFieldsAndScroll(async (err, values) => {
        if (!err) {
          let obj = {
            userid: this.itemData.userid,
            cid: this.$route.query.cid || 0,
            ...values
          }
          const chain = await this.ajaxEditTruename()
          chain.params(obj)
            .onSuccess(raw => {
              this.$emit('saveEdit', values.truename)
            })
            .onNetSuccess((res) => {
              if (res.data.error) {
                this.$message.warning(res.data.message || res.data.payload[0].message)
              }
            })
            .fetch()
        }
      })
    },
    resetForm () {
      // this.createForm.truename = ''
      this.form.setFieldsValue({ truename: '' })
      this.$emit('resetEdit')
    },
    getValLen (val) {
      let str = val.replace(/^\s+|\s+$/g, '')
      this.orgNameLen = str.length
    },
    getValue (e) {
      this.valData = e.target.value
    },
    async validNameEr (rule, value, callback) {
      if (value) {
        const chain = await this.validName()
        await chain.params({ truename: value })
          .onSuccess((raw) => {
          })
          .onNetSuccess((raw) => {
            const res = raw.data
            if (res.error) {
              callback(new Error(res.message || res.payload[0].message))
            } else {
              callback()
            }
          })
          .config({ tip: false })
          .fetch()
      }
    }
  }
}
</script>
<style lang="scss" scoped>
  .total-input-box {
        position: relative;
        .input-length-num {
        position: absolute;
        right: 10px;
      }
    }
</style>
